import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["ConfirmModalComponent"];
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormPreviewHeaderContainer } from './form-preview-header';
import { appHeaderHeight, AudioProvider, FakeBlurOverlay, formHeaderHeight, PinLayout } from '@lib/common';
import { PinnedQuestionComponent, PinnedSectionComponent, useConfirmSubmissionAudioModal, useSectionNavigationModal } from '@module/form-components';
import styled from 'styled-components';
import { SectionSummaryColumnContainer } from './section-summary-column';
import { ColorModeProvider, ThemeProvider } from '@xstyled/styled-components';
import { useTheme } from '@lib/common';
import { useFormPreview } from './hooks';
import { Skeleton } from 'antd';
import { SectionPreviewContainer } from './section';
import { resetFormPreviewAppState } from '../../redux/app.reducer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var paddingTopOfSectionSummary = 64;
export var marginBetweenItemsSectionSummary = 16;
var StyledContent = styled.div.withConfig({
  displayName: "form-previewcontainer__StyledContent",
  componentId: "sc-12aicck-0"
})(["display:flex;flex-direction:column;height:100%;width:100%;float:right;"]);

var FormPreview = function FormPreview(_ref) {
  var formId = _ref.formId,
      formPreviewLabels = _ref.formPreviewLabels,
      isModal = _ref.isModal,
      heightModal = _ref.heightModal,
      isHideAudioModal = _ref.isHideAudioModal,
      isHiddenCountDown = _ref.isHiddenCountDown,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'normal-form' : _ref$type;
  var dispatch = useDispatch();
  useEffect(function () {
    return function () {
      dispatch(resetFormPreviewAppState());
    };
  }, [dispatch]);

  var _useFormPreview = useFormPreview({
    formId: formId,
    formPreviewLabels: formPreviewLabels,
    type: type
  }),
      pinnedSectionId = _useFormPreview.pinnedSectionId,
      pinnedQuestionId = _useFormPreview.pinnedQuestionId,
      pinStatus = _useFormPreview.pinStatus,
      setPinStatus = _useFormPreview.setPinStatus,
      onCancelPin = _useFormPreview.onCancelPin,
      onPinQuestion = _useFormPreview.onPinQuestion,
      onPinSection = _useFormPreview.onPinSection,
      renderPinnedQuestionOrSection = _useFormPreview.renderPinnedQuestionOrSection,
      sectionSummaries = _useFormPreview.sectionSummaries,
      selectedSection = _useFormPreview.selectedSection,
      updateSelectedSection = _useFormPreview.updateSelectedSection;

  var _useSectionNavigation = useSectionNavigationModal({
    updateSelectedSection: updateSelectedSection,
    sectionSummaries: sectionSummaries,
    selectedSection: selectedSection,
    modalLabels: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.modalDialog
  }),
      ConfirmModalComponent = _useSectionNavigation.ConfirmModalComponent,
      sectionNavigation = _objectWithoutProperties(_useSectionNavigation, _excluded);

  var audioConfirmModalLabels = formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.useSubmissionAudioModalLabels;

  var _useConfirmSubmission = useConfirmSubmissionAudioModal({
    sections: sectionSummaries,
    labels: audioConfirmModalLabels
  }),
      hasConfirmedAudio = _useConfirmSubmission.hasConfirmedAudio,
      submissionHasAudio = _useConfirmSubmission.submissionHasAudio,
      SubmissionAudioConfirmModal = _useConfirmSubmission.SubmissionAudioConfirmModal;

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var renderPinnedItem = function renderPinnedItem() {
    var pinnedData = renderPinnedQuestionOrSection();
    if (!pinnedData) return null;
    var pinnedQuestion = pinnedData.pinnedQuestion,
        pinnedQuestionIndex = pinnedData.pinnedQuestionIndex,
        isSectionPinned = pinnedData.isSectionPinned,
        questionLabel = pinnedData.questionLabel,
        sectionLabel = pinnedData.sectionLabel,
        section = pinnedData.selectedSection,
        selectedSectionIndex = pinnedData.selectedSectionIndex,
        score = pinnedData.totalScore;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [pinnedQuestion && /*#__PURE__*/_jsx(PinnedQuestionComponent, {
        question: pinnedQuestion,
        index: pinnedQuestionIndex,
        label: questionLabel
      }), isSectionPinned && /*#__PURE__*/_jsx(PinnedSectionComponent, {
        section: section,
        sectionIndex: selectedSectionIndex,
        totalScore: score,
        label: sectionLabel
      })]
    });
  };

  var renderSectionQuestionColumn = function renderSectionQuestionColumn() {
    var _page$isLoadingForm, _page$isLoadingQuesti;

    var page = useSelector(function (state) {
      return state.formPreviewApp;
    });
    var isLoadingForm = (_page$isLoadingForm = page === null || page === void 0 ? void 0 : page.isLoadingForm) !== null && _page$isLoadingForm !== void 0 ? _page$isLoadingForm : false;
    var isLoadingQuestions = (_page$isLoadingQuesti = page === null || page === void 0 ? void 0 : page.isLoadingQuestions) !== null && _page$isLoadingQuesti !== void 0 ? _page$isLoadingQuesti : false;

    if (isLoadingForm || isLoadingQuestions || !selectedSection || sectionSummaries.length === 0) {
      return /*#__PURE__*/_jsxs(StyledContent, {
        style: {
          padding: '24px'
        },
        children: [/*#__PURE__*/_jsx(Skeleton, {
          active: true,
          paragraph: {
            rows: 3
          }
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Skeleton, {
          active: true,
          paragraph: {
            rows: 10
          }
        })]
      });
    }

    return /*#__PURE__*/_jsx(StyledContent, {
      children: sectionSummaries === null || sectionSummaries === void 0 ? void 0 : sectionSummaries.map(function (section, index) {
        if (!selectedSection) return /*#__PURE__*/_jsx(Skeleton, {});
        var isSelectedSection = section.id.toString() === (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.id.toString());
        if (!isSelectedSection) return null;
        return /*#__PURE__*/_jsx(SectionPreviewContainer, {
          index: index,
          section: section,
          onPin: onPinSection,
          pinnedSectionId: pinnedSectionId,
          onCancelPin: onCancelPin,
          labels: formPreviewLabels.section,
          onPinQuestion: onPinQuestion,
          pinnedQuestionId: pinnedQuestionId,
          formPreviewLabels: formPreviewLabels,
          onNextSection: function onNextSection() {
            sectionNavigation.onNextSection();
            var scrollContainer = document.querySelector('[data-submission-questions-scroll]');

            if (scrollContainer) {
              scrollContainer.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
              scrollContainer.scrollTop = 0;
            }

            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          },
          onPreviousSection: function onPreviousSection() {
            sectionNavigation.onPreviousSection();
            var scrollContainer = document.querySelector('[data-submission-questions-scroll]');

            if (scrollContainer) {
              scrollContainer.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
              scrollContainer.scrollTop = 0;
            }

            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          },
          navigationLabels: {
            previousSection: formPreviewLabels.sectionSummary.previousSection,
            nextSection: formPreviewLabels.sectionSummary.nextSection
          },
          type: type
        });
      })
    });
  };

  var renderSectionSummaryColumn = function renderSectionSummaryColumn() {
    return /*#__PURE__*/_jsx(SectionSummaryColumnContainer, {
      isModal: isModal,
      heightModal: heightModal,
      onCancelPin: onCancelPin,
      sectionLabels: formPreviewLabels.sectionSummary,
      countDownLabels: formPreviewLabels.countDownTimer,
      updateSelectedSection: sectionNavigation.onChangeSectionFromSummary,
      isHiddenCountDown: isHiddenCountDown
    });
  };

  var renderContent = function renderContent() {
    if (submissionHasAudio && !hasConfirmedAudio && !isModal && !isHideAudioModal) {
      return /*#__PURE__*/_jsx(FakeBlurOverlay, {
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormPreviewHeaderContainer, {}), /*#__PURE__*/_jsx(PinLayout, {
            renderPinColumn: /*#__PURE__*/_jsx("div", {
              children: "Loading..."
            }),
            renderMainContentColumn: /*#__PURE__*/_jsx(StyledContent, {}),
            renderSummaryColumn: /*#__PURE__*/_jsx("div", {}),
            pinStatus: pinStatus,
            setPinStatus: setPinStatus,
            onClosePinnedItem: onCancelPin,
            pageHeaderHeight: appHeaderHeight + formHeaderHeight
          })]
        })
      });
    }

    var content = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormPreviewHeaderContainer, {}), /*#__PURE__*/_jsx(PinLayout, {
        renderPinColumn: renderPinnedItem(),
        renderMainContentColumn: renderSectionQuestionColumn(),
        renderSummaryColumn: renderSectionSummaryColumn(),
        pinStatus: pinStatus,
        setPinStatus: setPinStatus,
        onClosePinnedItem: onCancelPin,
        pageHeaderHeight: isModal ? formHeaderHeight : appHeaderHeight + formHeaderHeight,
        heightScreen: isModal && heightModal
      }), /*#__PURE__*/_jsx(ConfirmModalComponent, {})]
    });

    return content;
  };

  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(ColorModeProvider, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [!isModal && !isHideAudioModal && /*#__PURE__*/_jsx(SubmissionAudioConfirmModal, {}), renderContent()]
      })
    })
  });
};

export var FormPreviewContainer = function FormPreviewContainer(_ref2) {
  var formId = _ref2.formId,
      formPreviewLabels = _ref2.formPreviewLabels,
      _ref2$isModal = _ref2.isModal,
      isModal = _ref2$isModal === void 0 ? true : _ref2$isModal,
      _ref2$isHideAudioModa = _ref2.isHideAudioModal,
      isHideAudioModal = _ref2$isHideAudioModa === void 0 ? false : _ref2$isHideAudioModa,
      _ref2$heightModal = _ref2.heightModal,
      heightModal = _ref2$heightModal === void 0 ? '100vh' : _ref2$heightModal,
      isHiddenCountDown = _ref2.isHiddenCountDown,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'normal-form' : _ref2$type;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(AudioProvider, {
      children: /*#__PURE__*/_jsx(FormPreview, {
        formId: formId,
        formPreviewLabels: formPreviewLabels,
        heightModal: heightModal,
        isModal: isModal,
        isHiddenCountDown: isHiddenCountDown,
        isHideAudioModal: isHideAudioModal,
        type: type
      })
    })
  });
};